import checkout from "./form";

const {
  formField: { taxId, conpanyName, releaseDate, representative },
} = checkout;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
};

export default initialValues;
